import { type ModuleApiInfo } from "@client/content/selectors";
import { unwrapResponsePromise } from "@client/lib/api";
import { useI18n } from "@common/hooks/i18n";
import getOptions from "@common/lib/options";
import NetworkVolumeKpi, { type NetworkVolumeKpiChildrenArgs } from "@common/modules/affiliate/NetworkVolumeKpi";
import { KpiPlainItem } from "@common/modules/affiliate/Widget/Profile/KpiItem";
import { isMoney } from "@common/modules/data/lib";
import { type Data } from "@common/modules/data/types";
import Network from "@common/modules/network/types";
import React from "react";
import api from "../../api";

export type MapProps = {
  apiInfo: ModuleApiInfo;
  config: Data.NetworkVolumeConfig;
  cycleEndDate: string;
  currencyCode: string | null | undefined;
  userId: number;
};

export type ActionProps = {
  onClick: () => void;
};

export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  const options = React.useMemo(() => getOptions(i18n), [i18n]);

  const getAggregates = React.useCallback(
    (cycleEndDate: string) => unwrapResponsePromise(api.getCycleAggregates(props.apiInfo, cycleEndDate)),
    [props.apiInfo]
  );

  const getRankOptions = React.useCallback(
    () => options.getCustomOptions<Network.Api.RankOptionItem>("mlm", "ranks", {}, "memory"),
    [props.apiInfo]
  );

  return (
    <NetworkVolumeKpi
      config={props.config}
      cycleEndDate={props.cycleEndDate}
      getAggregates={getAggregates}
      getRankOptions={getRankOptions}
    >
      {(args: NetworkVolumeKpiChildrenArgs) => (
        <KpiPlainItem
          isLoading={args.isLoading}
          currencyCode={isMoney(props.config.aggregateBy) ? props.currencyCode : null}
          label={props.config.label ?? i18n.networkVolume}
          onClick={props.onClick}
          value={args.value}
        />
      )}
    </NetworkVolumeKpi>
  );
};
